import { fetchAll } from "@/api/temperaturesensordelay";

const state = {
  all: [],
  isLoading: false,
};

const actions = {
  cleanState({ commit }) {
    commit("cleanState");
  },

  async fetchAll({ dispatch, commit }) {
    try {
      dispatch(
        "overlay/show",
        { isShow: true, message: "Carregando Temperaturas ..." },
        { root: true }
      );
      const temperatureSensorDelay = await fetchAll();

      commit("setAll", temperatureSensorDelay);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    } finally {
      dispatch("overlay/show", false, { root: true });
    }
  },
};

const mutations = {
  setAll(state, temperatureSensorDelay) {
    state.all = temperatureSensorDelay;
  },

  setLoading(state, isLoading) {
    state.isLoading = isLoading;
  },

  cleanState(state) {
    state.all = [];
    state.isLoading = false;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
